import React, {useState} from "react";
import cn from "classnames";

import useConfig from "hooks/useConfig";
import "styles/pages/other.scss";
import {useGTMChange} from "hooks/useGTM";
import {trackOtherTicketType} from "lib/tracking";

import FeatureFlag from "components/helpers/FeatureFlag";
import TicketOptions from "components/others/TicketOptions";
import SmartCarnet from "components/others/SmartCarnet";
import Rovers from "components/others/Rovers";
import DaySave from "components/others/DaySave";
import BookingFees from "components/BookingFees";

const ticketTypes = {
  SMART_CARNET: "smart-carnet",
  ROVERS: "rovers",
  DAYSAVE: "daysave"
};

const OtherTickets = () => {
  const {
    disableBackground,
    featureFlags: {
      enableSmartCarnet
    }
  } = useConfig();

  const [ticketType, setTicketType] = useState(enableSmartCarnet ? ticketTypes.SMART_CARNET : ticketTypes.ROVERS);

  useGTMChange(ticketType, trackOtherTicketType);

  return (
    <div
      className={cn({
        "otrl-jp__widget__content" : !disableBackground,
      })}
    >
      <div
        data-test-id='jp__tab--other'
        className={cn({
          "otrl-jp__widget__stations" : !disableBackground,
        })}
      >
        <FeatureFlag name="hideSubNavigation" inverse={true}>
          <TicketOptions
            setFieldValue={setTicketType}
            ticketType={ticketType}
          />
        </FeatureFlag>
        {ticketType === ticketTypes.SMART_CARNET &&
          <SmartCarnet />
        }
        {ticketType === ticketTypes.ROVERS &&
          <Rovers />
        }
        {ticketType === ticketTypes.DAYSAVE &&
          <DaySave />
        }
        <BookingFees />
      </div>
    </div>
  );
};

export default OtherTickets;
